import { BankAccountRequestBaseModel } from './generics';

export class BankAccountRequestCreateModel extends BankAccountRequestBaseModel {
    constructor(init?: Partial<BankAccountRequestCreateModel>) {
        super(init);
        Object.assign(this, init);
    }
}
